import { render, staticRenderFns } from "./sok.vue?vue&type=template&id=3ae6f6b5&"
import script from "./sok.vue?vue&type=script&lang=js&"
export * from "./sok.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports